import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { ProblemForUserFacade } from '../../../../store/problem-user/facade';
import { ProblemModel } from '../../../../store/problem/model';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer } from '@angular/platform-browser';
import { UserModel } from '../../../../store/user/model';
import { DashboardModel } from '../../../../store/dashboard/model';
import { TopServiceModel } from '../../../../store/self-diagnostic/top-service/model';
import { UserFacade } from '../../../../store/user/facade';
import { TopServiceFacade } from '../../../../store/self-diagnostic/top-service/facade';
import { ServiceCatalogFacade } from '../../../../store/self-diagnostic/service-catalog/facade';
import { AbstractDashboardApiService } from '../../../../core/services/abstract/abstract-dashboard-api-service';
import notify from 'devextreme/ui/notify';
import { AppConstants } from '../../../../core/constants/app-constants';
import { filter } from 'rxjs/operators';
import { ServiceModel } from '../../../../store/self-diagnostic/service-catalog/model';
import { List } from '../../../../core/infrastructure/linq';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  host: {
    class: 'dashboard d-flex flex-column align-items-center',
  },
  standalone: false,
})
export class DashboardComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  private titleService = inject(Title);
  translate = inject(TranslateService);
  private problemForUserFacade = inject(ProblemForUserFacade);
  sanitizer = inject(DomSanitizer);
  private dashboardApiService = inject(AbstractDashboardApiService);
  private serviceCatalogFacade = inject(ServiceCatalogFacade);
  private topServiceFacade = inject(TopServiceFacade);
  private userFacade = inject(UserFacade);

  public user: UserModel;
  public isLanguageUa: boolean;

  public dashboard: DashboardModel = new DashboardModel();
  public topServices: TopServiceModel[] = [];

  private translateSub: Subscription;
  private problemForUserSub: Subscription;
  private topServiceSub: Subscription;
  private serviceCatalogSub: Subscription;
  private userSub: Subscription;

  private userFacadeSub: Subscription;
  private serviceCatalogFacadeSub: Subscription;
  private selfDiagnosisFacadeSub: Subscription;

  public ngOnDestroy() {
    this.translateSub?.unsubscribe();
    this.userSub?.unsubscribe();
    this.problemForUserSub?.unsubscribe();
    this.topServiceSub?.unsubscribe();
    this.serviceCatalogSub?.unsubscribe();

    this.userFacadeSub?.unsubscribe();
    this.serviceCatalogFacadeSub?.unsubscribe();
    this.selfDiagnosisFacadeSub?.unsubscribe();
  }

  public async ngOnInit() {
    // Page title
    this.translateSub = this.translate.get('TITLE_MAIN').subscribe(value => {
      this.titleService.setTitle(value);
    });

    this.userSub = this.userFacade.selected().subscribe(user => {
      this.user = { ...user };

      this.isLanguageUa = !this.user?.language || this.user?.language == AppConstants.LANGUAGE_UK;
    });

    this.problemForUserSub = this.problemForUserFacade.allProblems$.subscribe(problems => {
      if (problems.length) {
        this.goToProblemsPage();
      }
    });

    this.topServiceSub = this.topServiceFacade.entities$.pipe(filter(ts => Array.isArray(ts) && !!ts.length)).subscribe(ts$ => {
      this.serviceCatalogSub = this.serviceCatalogFacade.entities$.pipe(filter(s => Array.isArray(s) && !!s.length)).subscribe(s$ => {
        let services = new List<ServiceModel>(s$);
        let topServices = new List<TopServiceModel>(ts$).Select(ts => {
          return { ...ts };
        });

        topServices.ForEach(ts => {
          ts.service = { ...services.Single(s => s.id == ts.serviceId) };
        });

        this.topServices = topServices.OrderByDescending(ts => ts.rank).ToArray();
      });
    });

    await this.load();
  }

  private async load() {
    let response = await this.dashboardApiService.load().toPromise();

    if (response.isSucceeded) {
      this.dashboard = response.result;
    } else {
      notify('load error', 'error', 3000);
    }
  }

  public goToServiceCatalogPage() {
    this.router.navigate(['/self-diagnostic/service-catalog']);
  }

  public goToProblemsPage() {
    this.router.navigate(['/problem/dashboard']);
  }

  public createOrder(service: ServiceModel) {
    this.router.navigate(['/orders/order'], {
      queryParams: {
        categoryId: service.category.code,
        categoryName: this.isLanguageUa ? service.category.nameUa : service.category.nameRu,
        serviceId: service.code,
        serviceName: this.isLanguageUa ? service.nameUa : service.nameRu,
        serviceTypeId: null,
      },
    });
  }
}
